import { useQuery } from '@tanstack/react-query';
import { getCurrentUserProfile } from '@/lib/api/profile/profileApi';
import { userManagementQueryKeys } from '@/lib/query-keys/userManagement';

export const useUserProfileQuery = () => {
  return useQuery({
    queryKey: userManagementQueryKeys.profile(),
    queryFn: async () => getCurrentUserProfile(),
  });
};
